import angular from "angular";
import {
  FormViewService,
  vsServiceName as FormViewServiceName,
  FormViewController,
  vsName,
} from "../../../../records/forms/formView";
import { vsComponentName as lookupModalComponentOptionsName } from "./component";

export const vsServiceName = "lookupModalService";

export interface LookupModalOptions {
  name: string;
  model?: any;
}

export class LookupModalService {
  static $inject = ["$uibModal", FormViewServiceName];

  constructor(
    private readonly $uibModal: angular.ui.bootstrap.IModalService,
    private readonly formViewService: FormViewService
  ) {}

  openModal(config: LookupModalOptions) {
    const formViewConfig = this.formViewService.getFormViewConfig(config.name);

    const model = config.model ?? {};

    const $uibModalInstance = this.$uibModal.open({
      component: lookupModalComponentOptionsName,
      resolve: {
        config: () => config,
        formViewConfig: () => formViewConfig,
        model: () => model,
        onSubmit: [
          () => (formViewController: FormViewController) => {
            return formViewConfig
              ?.submitForm({ formViewController, model })
              .then((r) => $uibModalInstance.close(r.Result));
          },
        ],
        onCancel: [() => () => $uibModalInstance.dismiss("cancel")],
      },
    });

    return $uibModalInstance;
  }
}
